export const GENDER = ["male", "female"] as const;
export type Gender = (typeof GENDER)[number];
